
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardController from './project-donation-wizard.controller';
import ProjectDonationWizardTemplate from './project-donation-wizard.html';

export default class ProjectDonationWizardComponent {
		constructor() {
				this.templateUrl = ProjectDonationWizardTemplate;
				this.controller = ProjectDonationWizardController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					project: '<',
					rewards: '<',
					donation: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/project-donation-wizard.component.js